// Packages
import PropTypes from 'prop-types'

// Components
import PurchaseOrderForm from 'modules/PurchaseOrders/components/Form';

// Other
import useApi from 'hooks/useApi';

const PurchaseOrderCreateScreen = ({ onClose }) => {

    const { post: create, errors } = useApi('/purchaseorders', false);

    const submit = async (values) => {

        create(values, 'Purchase Order created!', '/purchaseorders/');
    }

    return(
        <PurchaseOrderForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

PurchaseOrderCreateScreen.propTypes = {
	onClose: PropTypes.func,
}

PurchaseOrderCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
}

export default PurchaseOrderCreateScreen;